export function fbqTrack(event, params) {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
        window.fbq('track', event, params || {});
    }
}
